import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, Stat } from "@/components/UI";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar } from "recharts";


export function Reports() {
  const [monthly, setMonthly] = useState(null);
  const [yearly, setYearly] = useState(null);
  useEffect(() => {
    api.get("/stock/reports/monthly").then(r => setMonthly(r.data)).catch(() => {});
    api.get("/stock/reports/yearly").then(r => setYearly(r.data)).catch(() => {});
  }, []);
  if (!monthly || !yearly) return <div className="text-[#8a938c]">Yükleniyor...</div>;
  return (
    <div className="space-y-8">
      {/* Bu ay */}
      <section data-testid="monthly-report">
        <h3 className="heading text-2xl mb-3">Bu Ay ({monthly.current_month})</h3>
        <p className="text-sm text-[#8a938c] -mt-2 mb-3">Aşağıdaki rakamlar sayım/mutabakat sonucu oluşan <b>Zayiat (Fire)</b> giderleridir. Tüketim düşümü Rasyon/Lely/Buzağı modüllerinde takip edilir.</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
          <Stat label="Toplam Zayiat Gideri" value={monthly.total_cost.toLocaleString("tr-TR")} unit="₺" tone="warn" />
          <Stat label="Fire Olan Kalem" value={monthly.items.length} />
          <Stat label="Sayım Yapılan" value={monthly.count_records ?? monthly.items.length} unit="kayıt" />
        </div>
        <div className="grid lg:grid-cols-3 gap-4">
          <Card className="lg:col-span-2 !p-0 overflow-hidden">
            <table className="data-table">
              <thead><tr><th>Kalem</th><th className="text-right">Fire Miktarı</th><th className="text-right">Zayiat Gideri</th></tr></thead>
              <tbody>
                {monthly.items.map(x => (
                  <tr key={x.name}>
                    <td className="font-semibold">{x.name}</td>
                    <td className="text-right tabnum">{x.quantity} {x.unit}</td>
                    <td className="text-right tabnum font-semibold text-[#C45B45]">{x.cost.toLocaleString("tr-TR")} ₺</td>
                  </tr>
                ))}
                {!monthly.items.length && <tr><td colSpan={3} className="text-center py-6 text-[#8a938c]">Bu ay fire/zayiat kaydı yok.</td></tr>}
              </tbody>
            </table>
          </Card>
          <Card>
            <div className="text-xs uppercase tracking-widest text-[#6b746c] mb-2">Son 12 Ay Zayiat Trendi</div>
            <div style={{ height: 200 }}>
              <ResponsiveContainer>
                <LineChart data={monthly.series}>
                  <XAxis dataKey="month" tick={{ fontSize: 10, fill: "#8a938c" }} tickFormatter={(v) => v.slice(5)} />
                  <YAxis tick={{ fontSize: 10, fill: "#8a938c" }} />
                  <Tooltip contentStyle={{ borderRadius: 6, border: "1px solid #E5E2DC" }} />
                  <Line type="monotone" dataKey="cost" stroke="#C45B45" strokeWidth={2.5} dot={{ r: 3, fill: "#C45B45" }} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </Card>
        </div>
      </section>

      <div className="h-px bg-[#E5E2DC]" />

      {/* Yıllık */}
      <section data-testid="yearly-report">
        <h3 className="heading text-2xl mb-3">Yıllık ({yearly.year})</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
          <Stat label={`${yearly.year} Toplam Zayiat`} value={yearly.total_cost.toLocaleString("tr-TR")} unit="₺" tone="accent" />
          <Stat label="Fire Olan Kalem" value={yearly.items.length} />
          <Stat label="Aylık Ortalama" value={(yearly.total_cost / 12).toLocaleString("tr-TR", { maximumFractionDigits: 0 })} unit="₺" />
        </div>
        <Card className="mb-4">
          <div className="text-xs uppercase tracking-widest text-[#6b746c] mb-2">Aylara göre zayiat dağılımı</div>
          <div style={{ height: 240 }}>
            <ResponsiveContainer>
              <BarChart data={yearly.monthly_series}>
                <XAxis dataKey="month" tick={{ fontSize: 10, fill: "#8a938c" }} tickFormatter={(v) => v.slice(5)} />
                <YAxis tick={{ fontSize: 10, fill: "#8a938c" }} />
                <Tooltip contentStyle={{ borderRadius: 6, border: "1px solid #E5E2DC" }} />
                <Bar dataKey="cost" fill="#2D4A36" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Card>
        <Card className="!p-0 overflow-hidden">
          <table className="data-table">
            <thead><tr><th>Kalem</th><th className="text-right">Yıllık Fire</th><th className="text-right">Yıllık Zayiat</th><th className="text-right">Aylık Ort. Fire</th><th className="text-right">Aylık Ort. Zayiat</th></tr></thead>
            <tbody>
              {yearly.items.map(x => (
                <tr key={x.name}>
                  <td className="font-semibold">{x.name}</td>
                  <td className="text-right tabnum">{x.total_quantity} {x.unit}</td>
                  <td className="text-right tabnum font-semibold text-[#C45B45]">{x.total_cost.toLocaleString("tr-TR")} ₺</td>
                  <td className="text-right tabnum text-sm">{x.monthly_average_qty} {x.unit}</td>
                  <td className="text-right tabnum text-sm">{x.monthly_average_cost.toLocaleString("tr-TR")} ₺</td>
                </tr>
              ))}
              {!yearly.items.length && <tr><td colSpan={5} className="text-center py-6 text-[#8a938c]">Bu yıl sayım kaydı yok.</td></tr>}
            </tbody>
          </table>
        </Card>
      </section>
    </div>
  );
}
